import { Plug } from '@plone/volto/components/manage/Pluggable';
import React, { FC, useEffect } from 'react';
import FacetFilter, {
  FacetMetadata,
  Facets,
  FacetValue,
  SelectedFacets,
} from '../Search/FacetFilter';
import SearchView, { SearchViewProps } from './SearchView';
import { useDispatch, useSelector } from 'react-redux';
// @ts-ignore
import { listGroups, searchContent } from '@plone/volto/actions';
import { Icon } from '@plone/volto/components';
import searchSVG from '../../../icons/search.svg';
import { AnyAction } from 'redux';
import { RootState } from '../../../store';

export interface FacettedSearchViewProps extends SearchViewProps {
  facets: Facets;
  selectedFacets: SelectedFacets;
  facetMetadata?: FacetMetadata;
  toggleFacet: (facetId: keyof Facets, facetValueId: FacetValue['id']) => void;
}

const FacettedSearchView: FC<FacettedSearchViewProps> = ({
  facets,
  selectedFacets,
  facetMetadata,
  toggleFacet,
  ...searchViewProps
}) => {
  const dispatch = useDispatch();
  // @ts-ignore
  const uid = useSelector((state) => state.router?.location?.query?.uid);
  // @ts-ignore
  const solrcollections = useSelector(
    (state: RootState) => state?.search?.subrequests?.solrcollections?.items,
  );
  // @ts-ignore
  const departments = useSelector((state) => state.groups?.groups);

  useEffect(() => {
    if (uid) {
      dispatch(
        searchContent(
          '/solr-collections',
          {
            UID: uid,
            fullobjects: true,
          },
          'solrcollections',
        ) as AnyAction,
      );
    }
    dispatch(listGroups() as AnyAction);
  }, [dispatch, uid]);

  let solrCollectionTitle = '' as string;
  let solrCollectionSelectedFacets = '' as string;
  if (Array.isArray(solrcollections) && solrcollections.length > 0) {
    solrCollectionTitle = solrcollections[0].title;
    const params = JSON.parse(solrcollections[0].params);
    solrCollectionSelectedFacets = params.search.facets;
  }

  const processFacet = (key: string, item: string) => {
    if (key === 'departments') {
      // @ts-ignore
      const department = departments.filter(
        (group: { groupname: string }) => group.groupname === item,
      )[0];
      return department?.title;
    }
    if (key === 'review_state') {
      const reviewStates = {
        in_work: 'In Bearbeitung',
        release_control: 'Zur Freigabe',
        discussion: 'Zur Diskussion',
        verified: 'Verifiziert',
      };
      // @ts-ignore
      return reviewStates[item] || item;
    }
    return item;
  };

  return (
    <div>
      <Plug
        pluggable="horn.above.content"
        id="facet-filter-plug"
        dependencies={[facets, selectedFacets, facetMetadata, toggleFacet]}
      >
        {uid == null ? (
          <FacetFilter
            facets={facets}
            selectedFacets={selectedFacets}
            metadata={facetMetadata}
            toggleFacet={toggleFacet}
          />
        ) : (
          <div className={'solrcollection-header'}>
            <h2 className={'solrcollection-title'}>{solrCollectionTitle}</h2>
            <ul className={'solrcollection-selected-facets'}>
              <li className={'solrcollection-icon'}>
                <Icon name={searchSVG} size="14px" />
              </li>
              {Object.entries(solrCollectionSelectedFacets).map(
                ([key, value]) =>
                  // @ts-ignore
                  value.map((item) => (
                    <li key={`${key}-${item}`}>{processFacet(key, item)}</li>
                  )),
              )}
            </ul>
          </div>
        )}
      </Plug>

      <SearchView {...searchViewProps} />
    </div>
  );
};

export default FacettedSearchView;
